module.exports = __webpack_public_path__ + "static/media/qr-code.e552660a.png";